import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import ClientTwo from '../../components/client-two'
import About from '../../components/about'
import BlogOne from '../../components/blog-one'
import TeamOne from '../../components/team-one'
import Footer from '../../components/footer'
import BgParallax from '../../components/bg-parallax'

import bg1 from '../../assets/images/agency.jpg'
import bg2 from '../../assets/images/cta.jpg'

import { LuDiamond } from '../../assets/icons/vander'
import { featureData } from '../../data/agency-data'

export default function IndexAgency() {
  return (
    <>
    <Navbar navLight={true}/>

    <section className="bg-half-260 d-table w-100 position-relative" id="home" >
      <BgParallax bg={bg1}/>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-7 col-md-7 text-center">
                  <div className="title-heading mt-5">
                      <LuDiamond className="h1 text-white title-dark"/>
                      <h1 className="display-4 text-white title-dark mb-3">Let's Get Started</h1>
                      <p className="para-desc text-light title-dark">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4">
                          <Link to="#" className="btn btn-primary mt-2 me-2">Get Started</Link>
                          <Link to="#" className="btn btn-outline-primary mt-2">Documentation</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="home-shape-arrow">
          <Link href="#" className="mouse-down"><i className="mdi mdi-arrow-down arrow-icon text-dark h5"></i></Link>
      </div> 
    </section>

    <section className="section" id="features">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <span className="badge bg-primary rounded-pill"> Services </span>
                      <h4 className="title mt-3 mb-4">Template Features</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {featureData.map((item,index)=>{
              return(
                <div className="col-md-4 col-12 mt-4 pt-2" key={index}>
                    <div className="features text-center px-lg-4">
                        <img src={item.image} className="avatar avatar-small" alt=""/>
                        <div className="content">
                            <h4 className="title mt-4">{item.title}</h4>
                            <p className="text-muted mb-0">{item.desc}</p>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className='position-relative'>
      <BgParallax bg={bg2}/>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-primary shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mt-5 pt-4">
                      <h4 className="title mb-4">Our Dream Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <TeamOne/>
      </div>

      <div className="container mt-100 mt-60">
          <About/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Latest Blog & News</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <BlogOne/>
      </div>
    </section>

    <section className="section pt-0">
      <div className="container">
          <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4>Take control of your business.</h4>
                          <p className="text-muted para-desc mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="/contact" className="btn btn-primary"><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                      </div>
                  </div>
              </div>
              <div className="feature-posts-placeholder"></div>
          </div>
      </div>
    </section>

    <section className="section bg-light pt-0">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <span className="badge bg-primary rounded-pill"> Subscribe </span>
                      <h4 className="title mt-3 mb-4">Sign up for our Newsletter</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-lg-9 mt-4 pt-2">
                  <form>
                      <div className="row justify-content-center align-items-center">
                          <div className="col-md-4">
                              <div className="mb-3">
                                  <label className="form-label">First Name <span className="text-danger">*</span></label>
                                  <input name="name" id="fname" type="text" className="form-control" placeholder="First Name :"/>
                              </div>
                          </div>
                          <div className="col-md-4">
                              <div className="mb-3">
                                  <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                  <input name="name" id="lname" type="text" className="form-control" placeholder="Last Name :"/>
                              </div> 
                          </div>
                          <div className="col-md-4">
                              <div className="mb-3">
                                  <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                  <input name="email" id="email" type="email" className="form-control" placeholder="Your email :"/>
                              </div> 
                          </div>
                          <div className="col-md-4">
                              <div className="d-grid">
                                  <button id="subscribe" type="submit" className="btn btn-primary mb-2">Subscribe</button>
                              </div>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
    </section>

    <Footer/>
    </>
  )
}
